import script from "./AdviceDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AdviceDialog.vue?vue&type=script&setup=true&lang=js"

import "./AdviceDialog.vue?vue&type=style&index=0&id=0bfc74ce&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bfc74ce"]])

export default __exports__